import PropTypes from 'prop-types';
import type * as React from 'react';
import { useContext } from 'react';
import { InternalRadioButtonContext } from '../RadioButtonContainer';

interface PlainProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
    name: string;
    label?: React.ReactNode;
    onChange: (value: any) => void;
}

export const RadioButtonPlain = ({
    name,
    value,
    label,
    className = undefined,
    style = undefined,
    onChange,
    ...otherProps
}: PlainProps) => {
    const id = name + '-' + value;
    const inputProps: React.InputHTMLAttributes<HTMLInputElement> = {
        ...otherProps,
        type: 'radio',
        name,
        value,
        id,
        onChange: event => onChange(event.target.value),
    };
    const testId = `radio-button-${value}${otherProps.checked ? '-checked' : ''}`;
    return label ? (
        <div className={className} style={style}>
            <input {...inputProps} data-testid={testId} />
            <label htmlFor={id}>{label}</label>
        </div>
    ) : (
        <input {...inputProps} data-testid={testId} />
    );
};

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: React.ReactNode;
}

export default function RadioButton(props: Props) {
    const { name, selected, onChange } = useContext(InternalRadioButtonContext);
    const { value, label, className, style } = props;
    const mergedProps = {
        ...props,
        name,
        value,
        checked: selected === value,
        onChange: () => onChange(value),
        label,
        className,
        style,
    };
    return <RadioButtonPlain {...mergedProps} />;
}

RadioButton.propTypes = {
    value: PropTypes.any,
};

RadioButton.contextTypes = {
    radioButtonContainer: PropTypes.object,
};
